/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Anlieferkennzeichen } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * AnlieferkennzeichenService - axios parameter creator
 * @export
 */
export const AnlieferkennzeichenServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Anlieferkennzeichen
         * @summary Anlieferkennzeichen
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnlieferkennzeichen: async (mandant?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/anlieferkennzeichen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mandant !== undefined) {
                localVarQueryParameter['mandant'] = mandant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnlieferkennzeichenService - functional programming interface
 * @export
 */
export const AnlieferkennzeichenServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnlieferkennzeichenServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Anlieferkennzeichen
         * @summary Anlieferkennzeichen
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAnlieferkennzeichen(mandant?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Anlieferkennzeichen>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAnlieferkennzeichen(mandant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnlieferkennzeichenService - factory interface
 * @export
 */
export const AnlieferkennzeichenServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnlieferkennzeichenServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Anlieferkennzeichen
         * @summary Anlieferkennzeichen
         * @param {number} [mandant] mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAnlieferkennzeichen(mandant?: number, options?: any): AxiosPromise<Array<Anlieferkennzeichen>> {
            return localVarFp.getAnlieferkennzeichen(mandant, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnlieferkennzeichenService - interface
 * @export
 * @interface AnlieferkennzeichenService
 */
export interface AnlieferkennzeichenServiceInterface {
    /**
     * Liefert eine Liste von Anlieferkennzeichen
     * @summary Anlieferkennzeichen
     * @param {number} [mandant] mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnlieferkennzeichenServiceInterface
     */
    getAnlieferkennzeichen(mandant?: number, options?: any): AxiosPromise<Array<Anlieferkennzeichen>>;

}

/**
 * AnlieferkennzeichenService - object-oriented interface
 * @export
 * @class AnlieferkennzeichenService
 * @extends {BaseAPI}
 */
export class AnlieferkennzeichenService extends BaseAPI implements AnlieferkennzeichenServiceInterface {
    /**
     * Liefert eine Liste von Anlieferkennzeichen
     * @summary Anlieferkennzeichen
     * @param {number} [mandant] mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnlieferkennzeichenService
     */
    public getAnlieferkennzeichen(mandant?: number, options?: any) {
        return AnlieferkennzeichenServiceFp(this.configuration).getAnlieferkennzeichen(mandant, options).then((request) => request(this.axios, this.basePath));
    }
}
